import { navigate as navigateTo } from "gatsby";
import { getCurrentLocale } from "../providers/LocaleSwitcherProvider";

export enum PATHS {
  REDEEM = "/redeem",
  REDEEM_GAME_SELECTION = "/redeem/game-selection",
  REDEEM_BUYER_INFO = "/redeem/buyer-info",
  REDEEM_SUMMARY = "/redeem/summary",
  REDEEM_SUCCESS = "/redeem/success",
  REDEEM_SUMMARY_ERROR_GENERIC = "/redeem/summary/error/sorry",
  REDEEM_SUMMARY_ERROR_ALREADY_OWNED = "/redeem/summary/error/already-owned",
  REDEEM_SUMMARY_ERROR_INCORRECT_REGION = "/redeem/summary/error/incorrect-region",
  REDEEM_SUMMARY_ERROR_NOT_PLAYED = "/redeem/summary/error/not-played",
  REDEEM_SUMMARY_ERROR_UNIQUE_CODE_REDEEMED = "/redeem/summary/error/unique-code-redeemed",
  // Cash code specific errors
  REDEEM_SUMMARY_ERROR_CODE_ALREADY_REDEEMED = "/redeem/summary/error/code-already-redeemed",
  REDEEM_SUMMARY_ERROR_CODE_DEACTIVATED = "/redeem/summary/error/code-deactivated",
  REDEEM_SUMMARY_ERROR_CODE_EXPIRED = "/redeem/summary/error/code-expired",
  REDEEM_SUMMARY_ERROR_CODE_NOT_FOUND = "/redeem/summary/error/code-not-found",
  REDEEM_SUMMARY_ERROR_CONSENT_REQUIRED = "/redeem/summary/error/consent-required",
  REDEEM_SUMMARY_ERROR_INTERNAL_ERROR = "/redeem/summary/error/internal-error",
  REDEEM_SUMMARY_ERROR_INVALID_AGE = "/redeem/summary/error/invalid-age",
  REDEEM_SUMMARY_ERROR_INVALID_AMOUNT_OR_CURRENCY = "/redeem/summary/error/invalid-amount-or-currency",
  REDEEM_SUMMARY_ERROR_INVALID_CODE = "/redeem/summary/error/invalid-code",
  REDEEM_SUMMARY_ERROR_INVALID_COUNTRY = "/redeem/summary/error/invalid-country",
  REDEEM_SUMMARY_ERROR_INVALID_DATE_OF_BIRTH = "/redeem/summary/error/invalid-date-of-birth",
  REDEEM_SUMMARY_ERROR_INVALID_FIRST_NAME = "/redeem/summary/error/invalid-first-name",
  REDEEM_SUMMARY_ERROR_INVALID_LAST_NAME = "/redeem/summary/error/invalid-last-name",
  REDEEM_SUMMARY_ERROR_INVALID_REGION = "/redeem/summary/error/invalid-region",
  REDEEM_SUMMARY_ERROR_KR_NATIONAL_ID_REQUIRED = "/redeem/summary/error/kr-national-id-required",
  REDEEM_SUMMARY_ERROR_NATIONAL_ID_REJECTED = "/redeem/summary/error/national-id-rejected",
  REDEEM_SUMMARY_ERROR_PAYMENT_SESSION_INVALID_OR_EXPIRED = "/redeem/summary/error/payment-session-error",
  REDEEM_SUMMARY_ERROR_REDEMPTION_LIMIT_REACHED = "/redeem/summary/error/redemption-limit",
}

export const navigate = (path: string | number) => {
  // -1 works as the back button
  if (path === -1) {
    navigateTo(path);
  } else {
    let locale = "";

    // Window should never be undefined, but check is needed for Gatsby build:
    if (window !== undefined) {
      locale = getCurrentLocale(window.location.pathname);
    }

    navigateTo(`/${locale}${path}${location.search}`);
  }
};
